module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel02_1280_1280_th-53abce1d1b19de4472960fc30a82e876.jpg";